// extracted by mini-css-extract-plugin
export var closeButton = "_1k-1";
export var container = "_1k-0";
export var fullModalImage = "_1k-2";